const MenuItem = ({
  icon,
  label,
  onClick,
  actionId,
  destructive = false,
}: {
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
  actionId?: string;
  destructive?: boolean;
}) => (
  <button
    onClick={onClick}
    data-action-id={actionId}
    className="w-full min-h-[var(--tap-min)] px-4 py-3.5 flex items-center gap-3.5 text-start rounded-2xl hover:bg-[var(--fill-1)] active:bg-[var(--fill-2)] transition-colors"
  >
    <span
      className={
        destructive ? "text-[var(--destructive)]" : "text-[var(--text-tertiary)]"
      }
    >
      {icon}
    </span>
    <span
      className={`text-[15px] font-medium ${
        destructive ? "text-[var(--destructive)]" : "text-[var(--text-primary)]"
      }`}
    >
      {label}
    </span>
  </button>
);

export default MenuItem;
